module.exports = __webpack_public_path__ + "kudos_80.svg?e3c770b0bdedf514d1866c339f153150";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_80.svg
// module id = 184
// module chunks = 0